<template>
  <panel-navigation><Videos /></panel-navigation>
</template>
<script>
import PanelNavigation from '@/components/PanelNavigation.vue';
import Videos from './Videos.vue';
export default { components: { PanelNavigation, Videos } };
</script>
